import Menu from "common-components/dist/common/components/Menu";

export default Menu;
